import classNames from 'classnames';
import React, { useRef } from 'react';
import { mapAudio } from '../helpers/AudioHelper';
import css from './Keypad.module.scss';

export default function Keypad(props: {
    className?: string
    onKeyPressed: (digit: string) => void
}) {
    const audioRef = useRef<HTMLAudioElement>(null)

    function handleDtmfClick(digit: string) {
        props.onKeyPressed(digit)
        if (!audioRef.current) { return }
        try {
            if (digit === '*') {
                audioRef.current.src = mapAudio(require('./sounds/dtmf-star.mp3'))
            } else if (digit === '#') {
                audioRef.current.src = mapAudio(require('./sounds/dtmf-hash.mp3'))
            } else {
                audioRef.current.src = mapAudio(require(`./sounds/dtmf-${digit}.mp3`))
            }
        } catch (err) {
            console.error('failed to set dtmf audio for', digit, err)
        }
    }

    function renderButton(digit: string, footer: string | null = null, bigFooter: boolean = false) {
        return <button onClick={() => handleDtmfClick(digit)}>
            {digit}
            <div className={classNames(bigFooter && css.big)}>{footer}</div>
        </button>
    }

    return (
        <div className={classNames(props.className, css.dialpad)}>
            {renderButton('1')}
            {renderButton('2', 'ABC')}
            {renderButton('3', 'DEF')}
            {renderButton('4', 'GHI')}
            {renderButton('5', 'JKL')}
            {renderButton('6', 'MNO')}
            {renderButton('7', 'PQRS')}
            {renderButton('8', 'TUV')}
            {renderButton('9', 'WXYZ')}
            {renderButton('*')}
            {renderButton('0', '+', true)}
            {renderButton('#')}
            <audio autoPlay ref={audioRef} />
        </div>
    )
}